import { attachComponent } from 'jms-domain'

import { entityHeaderComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton } from '@salsita-ai/platform-project-sdk/react'

export const wallItemComponents = [
  attachComponent
    .withComponent(entityHeaderComponent, 'default')
    .withAlias('WallItem')
    .attach(
      memoEval(
        s => [s.id],
        id => ({
          secondaryButton: <DeleteEntityButton entityId={id} />,
        })
      )
    ),
]
